export const SEARCH_PARAM_SHOW = 'tab';
export const SEARCH_PARAM_STATION_ID = 'station-id';
export const SEARCH_PARAM_STATIONS = 'stations';
export const SEARCH_PARAM_INCIDENTS = 'incidents';
export const SEARCH_PARAM_INCIDENT_ID = 'incident-id';
// TODO: rename this key with proper name
export const SEARCH_PARAM_LOCK_PIN = 'lock-pin';
export const SEARCH_PARAM_LOCK_PIN_TYPE = 'lock-type';
export const SEARCH_PARAM_LOCK_PIN_SECTION_ID = 'lock-pin-section';
export const SEARCH_PARAM_ROUTE_LINE_NUMBER = 'route-number';

export const SEARCH_PARAM_ROUTES = 'routes';
export const SEARCH_PARAM_MONITOR = 'monitor';
export const SEARCH_PARAMS_ROUTE_ID = 'route-id';
export const SEARCH_PARAM_MONITOR_PASSENGER = 'passenger-monitor';
export const SEARCH_PARAM_MONITOR_RHB = 'rhb-monitor';
export const SEARCH_PARAM_ROUTE_TYPE = 'route-type';
export const SEARCH_PARAM_SORT_BY = 'route-sort-by';
export const SEARCH_PARAM_SELECTED_DATE = 'selected-date';
export const SEARCH_PARAM_JOURNEY_ID = 'selected-journey';
export const SEARCH_PARAM_VIEW = 'view';
export const SEARCH_PARAM_VEREINA_STATUS = 'vereina-status';
export const VIEW_LADDER = 'ladder';
export const SEARCH_PARAM_DRAWER = 'drawer';
export const SEARCH_PARAM_SECTION_ID = 'section';
export const SEARCH_PARAM_SLOW_SECTION_ID = 'slow-section-id';
export const SEARCH_PARAM_SLOW_SECTIONS = 'slow-sections';
export const SEARCH_PARAM_INCIDENT_SEARCH = 'incident-search';
export const SEARCH_PARAM_STATION_SEARCH = 'station-search';
export const SEARCH_PARAM_ROUTE_SEARCH = 'route-search';

export const SEARCH_PARAMS_ADMIN_CONTROL_TAB = 'admin-control-tab';

export const SEARCH_PARAMS_PAGE = 'page';
export const SEARCH_PARAMS_LIMIT = 'limit';
